import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-540dfe1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-status" }
const _hoisted_2 = { class: "xag-ellipsis title" }
const _hoisted_3 = { class: "type-no" }

import { useRouter } from 'vue-router'
import { withDefaults, computed } from 'vue'
import { RepairOrderStatusColorMap } from '@/defination/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import {
  MalfunctionRepairServiceOrderRepairOrderItem,
  MalfunctionRepairServiceOrderStandbyMachinesOrderItem,
} from '@/types/malfunction-repair'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-repair-record',
  props: {
    order: { default: () => null },
    showBottomBorder: { type: Boolean, default: true },
    serviceGuid: { default: '' },
    servoceNo: { default: '' }
  },
  setup(__props: any) {

const props = __props as { order:
      | MalfunctionRepairServiceOrderRepairOrderItem
      | MalfunctionRepairServiceOrderStandbyMachinesOrderItem, showBottomBorder: boolean, serviceGuid: string, servoceNo: string };

const $router = useRouter()

const { addServiceOrderKeepAlive } = useMalfunctionRepairStore()
const isStangbyMachine = computed(() => {
  const result: any = props.order
  return !!result.sn
})
// 判断服务费用单
const isServiceCharge = computed(() => {
  const result: any = props.order
  return !!result.order_no
})
// 判断升级保养单
const isUpgradeMaintenance = computed(() => {
  const result: any = props.order
  return result.is_package
})

const snValue = computed(() => {
  const result: any = props.order
  if (isStangbyMachine.value) {
    return result.sn
  } else if (isServiceCharge.value) {
    return result.order_no
  } else {
    return result.repair_sn
  }
})
const type = computed(() => {
  let type = ''
  if (isStangbyMachine.value) {
    type = '备用机单据'
  } else if (isServiceCharge.value) {
    type = '服务费用单'
  } else if(isUpgradeMaintenance.value){
    type = '升级保养'
  }else {
    type = '维修单据'
  }
  return type
})
const unJumpToDetail = computed(() => {
  const status = `${props.order.status}`
  return (
    (status === '14' || status === '16') && !isStangbyMachine.value && !isUpgradeMaintenance.value
  )
})
function getTextColorStyle(color_number: number) {
  return `color: ${RepairOrderStatusColorMap.get(color_number + '')}`
}

function toRepairOrderDetail() {
  if (unJumpToDetail.value) {
    // 维修单、升级保养再已取消、已取消-待退料状态下不给客户点击
    return
  }
  try {
    addServiceOrderKeepAlive()
    setTimeout(() => {
      if (isStangbyMachine.value) {
        $router.push({
          path: `/reserveorder/${props.order.guid}`,
        })
      } else if (isServiceCharge.value) {
        $router.push({
          name: 'malfunction-repair-service-bill-detail',
          query: {
            guid: props.order.guid,
            serviceGuid: props.serviceGuid,
          },
        })
      } else if (isUpgradeMaintenance.value) {
        $router.push({
          name: 'malfunction-upgrade-maintenance-detail',
          query: {
            guid: props.order.guid,
            serviceGuid: props.serviceGuid,
          },
        })
      } else {
        $router.push({
          name: 'malfunction-repair-repair-order-detail',
          query: {
            guid: props.order.guid,
            serviceGuid: props.serviceGuid,
            serviceNo: props.servoceNo,
          },
        })
      }
    }, 100)
  } catch (error) {
    console.log('error', error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["repair-record", props.showBottomBorder ? 'van-hairline--bottom' : ''])
  }, [
    _createElementVNode("div", {
      class: "record-info",
      onClick: toRepairOrderDetail
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(type)), 1),
        _createElementVNode("div", {
          class: "status-text",
          style: _normalizeStyle(getTextColorStyle(__props.order.status_color))
        }, _toDisplayString(__props.order.status_text), 5),
        _createElementVNode("i", {
          class: _normalizeClass(["icon-arrow-right-svg", _unref(unJumpToDetail) ? 'transparent-item' : ''])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.order.service_type) + _toDisplayString(__props.order.service_type ? '｜' : '') + _toDisplayString(_unref(snValue)), 1)
    ])
  ], 2))
}
}

})